module.exports = __webpack_public_path__ + "static/briga-o-gostima-5586c1c522cc7c200f83a67c566eed79.svg";